@if (selectedQrMode === qrMode.camera && showCameraList) {
  <div>
    <lib-amdocs-dropdown [elementId]="'camera-dd'"
      [items]="cameraList"
      [control]="cameraCtrl"
      [label]="'Camera list'" />
  </div>
}
<div id="reader-wrapper">
  <div id="reader"></div>
</div>
@if (selectedQrMode === qrMode.file) {
  <div class="reader-input-wrapper">
    <div class="btn btn-medium primary upload-button">
      {{uploadBtnText}}
      <input type="file" name="upload-qr" accept="image/*" (change)="handleQrUpload($event)" />
    </div>
  </div>
}
